import React, { Component } from "react";
import { connect } from "react-redux";
import Pagination from "../2/Controls/Pagination";
import Spinner from "../Common/Spinner";
import CustomTable from "../2/Controls/CustomTable";
import DynamicButtonTabs from "../2/Controls/DynamicButtonTabs";
import NewImageButton from "../2/Controls/NewImageButton";
import { isMobileApp } from "../../actions/Util";
import Window from "../2/Controls/Window";
import Input from "../2/Controls/Input";
import TicketDetails from "./TicketDetails";
import NewButton from "../2/Controls/NewButton";
import AddTicket from "./AddTicket";

class TicketsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      activePage: 0,
      itemsCountPerPage: 25,
      recordFrom: 0,
      totalItemsCount: 0,
      ticketsList: [],
      activeTab: "all",
      showFilter: false,
      selectedTicket:{},
      showTicketDetail:false,
      statusCount:{},
       filter: {  // Add this
      ticketNo: "",
      fromDate: "",
      toDate: "",
      customerName: "",
      customerPhoneNo: "",
      customerEmail: "",
      storeId:"",
      showNewTicket:false
    }
    };
  }

  componentDidMount() {
     // Set default storeId from props
  const defaultStoreId =  this.props.user.store.key;
  
  this.setState({
    filter: {
      ...this.state.filter,
      storeId: defaultStoreId
    }
  }, () => {
    this.fetchTickets();
  });
}

fetchTickets = async () => {
  const { activePage, itemsCountPerPage, activeTab, filter } = this.state;

  this.setState({ loading: true });

  try {
    // Pass status only if activeTab is not "all"
    const status = activeTab !== "all" ? activeTab : "";

     let storeIds = filter.storeId ? [filter.storeId] : [];
    // If storeId is empty, get all store keys from props
    if (!filter.storeId && this.props.config && this.props.config.UserStores) {
    storeIds = this.props.config.UserStores
        .filter(store => store.key && store.key !== "")
        .map(store => store.key);
    }
    
    const storeIdsParam = storeIds.length > 0 ? JSON.stringify(storeIds) : storeIds;
    const response = await this.props.getHelpDeskTickets(
      this.props.registration.registration.key,
      storeIdsParam,
      status,
      filter.customerName || "",
      filter.customerPhoneNo || "",
      filter.customerEmail || "",
      filter.fromDate || "",
      filter.toDate || "",
      filter.ticketNo ||"",
    );

    let tickets=[];
    let statusCount={};

    if(response.code=="0"){
      tickets=response.data;
      statusCount=response.StatusCount
    }
    // Filter by ticket number locally (since API doesn't have ticketNo param)
    let filteredTickets = Array.isArray(tickets) ? tickets : [];

    const start = activePage * itemsCountPerPage;
    const end = start + itemsCountPerPage;
    const paginatedTickets = filteredTickets.slice(start, end);

    this.setState({
      ticketsList: paginatedTickets,
      totalItemsCount: filteredTickets.length,
      statusCount:statusCount,
      loading: false
    });
  } catch (error) {
    console.error("Error fetching tickets:", error);
    this.setState({
      ticketsList: [],
      totalItemsCount: 0,
      loading: false
    });
  }
};

  onRefresh = () => {
    this.setState({ activePage: 0 }, () => {
      this.fetchTickets();
    });
  };

  onRecordsPerPageCountChange = (newRowsPerPage) => {
    this.setState({
      itemsCountPerPage: newRowsPerPage,
      activePage: 0
    }, () => {
      this.fetchTickets();
    });
  };

  onTabChange = (tab) => {
    this.setState({
      activeTab: tab.value,
      activePage: 0
    }, () => {
      this.fetchTickets();
    });
  };

  getColumns = () => {
    const isMobile = isMobileApp();

    return [
      {
        field: "TicketNumber",
        headerName: "Ticket No",
        type: "text",
        hideOnMobile: false,
      },
      {
        field: "Type",
        headerName: "Type",
        type: "text",
        hideOnMobile: false
      },
      {
        field: "SubType",
        headerName: "Sub Type",
        type: "text",
        hideOnMobile: isMobile
      },
      {
        field: "Customer",
        headerName: "Customer",
        type: "text",
        hideOnMobile: isMobile,
        renderCell: ({ row }) => {
          if (row.hasOwnProperty("Customer") && row.Customer) {
            const firstName = row.Customer.FirstName || "";
            const lastName = row.Customer.LastName || "";
            const phoneNo = row.Customer.PhoneNo || "";
            const emailId = row.Customer.EmailID || "";

            const customerName = `${firstName} ${lastName}`.trim();

            // Build the display content
            const parts = [];
            if (customerName) parts.push(customerName);
            if (phoneNo) parts.push(`${phoneNo}`);
            if (emailId) parts.push(`${emailId}`);

            return parts.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                {parts.map((part, index) => (
                  <div key={index}>{part}</div>
                ))}
              </div>
            ) : "-";
          }
          return "-";
        }
      },
      {
        field: "Status",
        headerName: "Status",
        type: "text",
        hideOnMobile: false,
        renderCell: ({ row }) => {
          const statusColor = {
            "New": "#f59e0b",
            "In Progress": "#3b82f6",
            "Pending Customer": "#8b5cf6",
            "Resolved": "#10b981",
            "Closed": "#6b7280"
          };

          const statusColorValue = statusColor[row.Status] || "#6b7280";

          return <span style={{ color: statusColorValue, fontWeight: "500" }}>
            {row.Status}
          </span>;
        }
      },
     {
  field: "Priority",
  headerName: "Priority",
  type: "text",
  hideOnMobile: false,
  renderCell: ({ row }) => {
    const priorityColor = {
      Low: "#10b981",      // Green
      Medium: "#f59e0b",   // Orange
      High: "#ef4444",     // Red
      Urgent: "#7c3aed",   // Purple
    };

    const color = priorityColor[row.Priority] || "#6b7280";

    return (
      <span style={{ color, fontWeight: 500 }}>
        {row.Priority}
      </span>
    );
  },
},
      // {
      //   field: "Description",
      //   headerName: "Description",
      //   type: "text",
      //   hideOnMobile: isMobile
      // },
      {
  field: "createdAt",
  headerName: "Received Date",
  hideOnMobile: false,
  renderCell: ({ row }) => {
    const date =  row.createdAt;

    return date
      ? new Date(date).toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        })
      : "-";
  }
},

{
  field: "",
  headerName: "Agent",
  type: "text",
  hideOnMobile: isMobile,
  renderCell: ({ row }) => {
    if (row.hasOwnProperty("AssignTo") && row.AssignTo) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <div>{row.AssignTo.EmployeeName}</div>
        </div>
      );
    }
    return "-";
  }
}
    ];
  };

renderStatusFilters = () => {
  const { activeTab, statusCount } = this.state;

  // Define the tabs with their corresponding status keys
  const tabs = [
    { label: "All", value: "all" },
    { label: "New", value: "New" },
    { label: "In Progress", value: "In Progress" },
    { label: "Pending Customer", value: "Pending Customer" },
    { label: "Resolved", value: "Resolved" },
    { label: "Closed", value: "Closed" }
  ];

  // Format tabs with counts
  const tabsWithCounts = tabs.map(tab => {
    let count = 0;
    if (tab.value === "all") {
      // Sum all status counts for "All" tab
      if (statusCount) {
       count = tabs
          .filter(t => t.value !== "all")
          .reduce((sum, t) => sum + (statusCount[t.value] || 0), 0);
      
      }
    } else if (statusCount && statusCount[tab.value] !== undefined) {
      count = statusCount[tab.value];
    }
    
    // Return tab with count property (only if count > 0)
    return {
      ...tab,
      count: count // Pass count as a separate property
    };
  });

  return (
    <DynamicButtonTabs
      connected={true}
      tabs={tabsWithCounts}
      activeTab={activeTab}
      onTabChange={this.onTabChange}
    />
  );
};
onApplyFilter = () => {
  this.setState({ 
    activePage: 0,
    showFilter: false 
  }, () => {
    this.fetchTickets();
  });
}
  onClearFilter = () => {
  this.setState({ 
    filter: {
      ticketNo: "",
      fromDate: "",
      toDate: "",
      customerName: "",
      customerPhoneNo: "",
      customerEmail: ""
    },
    activePage: 0 
  }, () => {
    this.fetchTickets();
    this.setState({ showFilter: false });
  });
}


onSaveTicket=()=>{
  this.setState({showNewTicket:false});
  this.onRefresh()
}

  render() {
    const { ticketsList, loading, activePage, itemsCountPerPage, totalItemsCount, showFilter } = this.state;

    return (
      <>
        {!this.state.showTicketDetail && <div className="header-margin">
          <div style={{ padding: "10px" }}>
            <div className="listing-page-header">
              <div className="left left-40">
                <div className="listing-page-header-title">
                  Tickets List
                </div>
              </div>
              <div className="right right-60">
                <div className="btn-group pull-right hidden-xs" style={{ paddingRight: "10px" }}>
                  {this.renderStatusFilters()}
                </div>
               <NewButton
              type={"primary"}
              text={"New"}
              icon={"add"}
              onClick={() =>{this.setState({showNewTicket:true})}}
            />
                <NewImageButton
                  type="refresh"
                  label=""
                  onClick={this.onRefresh}
                />
                <NewImageButton
                  type="filter"
                  label=""
                  onClick={() => this.setState({ showFilter: !showFilter })}
                />
              </div>
            </div>
            <div
              className="listing-page-content"
              style={{
                height: window.innerHeight - 138 + "px",
                overflowY: "auto",
                overflowX: "hidden",
                position: "relative",
                backgroundColor: "white"
              }}
            >
              <CustomTable
                columns={this.getColumns()}
                loading={loading}
                rows={ticketsList}
                handleOnRow={(row)=>{this.setState({selectedTicket:row,showTicketDetail:true})}}
                loadingRows={25}
                showTextOnRows={ticketsList.length ? null : "No data found!"}
              />
            </div>
            {totalItemsCount > 0 && (
              <Pagination
                count={totalItemsCount}
                page={activePage + 1}
                rowsPerPage={itemsCountPerPage}
                onPageChange={(newPage) => {
                  this.setState({ activePage: newPage - 1 }, () => {
                    this.fetchTickets();
                  });
                }}
                onRowsPerPageChange={this.onRecordsPerPageCountChange}
                isCompress={false}
              />
            )}
          </div>
        </div>}
        
        {this.state.showTicketDetail &&
        <TicketDetails   {...this.props} ticket={this.state.selectedTicket} onClose={()=>{this.setState({showTicketDetail:false})}}/>

        }
        {this.state.showFilter &&

          <Window

            header="Filter"

            size="small"

            slide={true}

            onClose={() =>

              this.setState({
                showFilter: false
              })

            }

         onButtonClick={(action) => {
  if (action === "Apply") {
    this.onApplyFilter();
  } else if (action === "Clear") {
    this.onClearFilter();
  }
}}

            buttons={[
              {
                Type: "secondary",
                Text: "Clear",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Apply",
                Align: "right"
              }
            ]}

          >

               <Input
                          type="select"
                          label="Store"
                          value={this.state.filter.storeId}
                          onChange={(v) => {
                            this.setState({
                              filter: { ...this.state.filter, storeId: v }
                            });
                          }}
                        >
                          {this.props.config.UserStores.map((s) => (
                            <option key={s.key} value={s.key}>
                              {s.StoreCode} {s.StoreName}
                            </option>
                          ))}
                        </Input>

            <Input
              type="text"
              label="Ticket No"
              value={this.state.filter.ticketNo}
              onChange={(value) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    ticketNo: value
                  }
                })
              }
            />

                <Input
              type="date"
              label="From Date"
              value={this.state.filter.fromDate}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, fromDate: v }
                })
              }
            />

            <Input
              type="date"
              label="To Date"
              value={this.state.filter.toDate}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, toDate: v }
                })
              }
            />

            <Input
              type="text"
              label="Customer Name"
              value={this.state.filter.customerName}
              onChange={(value) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    customerName: value
                  }
                })
              }
            />

            <Input
              type="text"
              label="Customer Phone No"
              value={this.state.filter.customerPhoneNo}
              onChange={(value) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    customerPhoneNo: value
                  }
                })
              }
            />

             <Input
              type="text"
              label="Customer Email"
              value={this.state.filter.customerEmail}
              onChange={(value) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    customerEmail: value
                  }
                })
              }
            />






          </Window>


        }

        {this.state.showNewTicket &&
        <AddTicket {...this.props} onClose={()=>{this.setState({showNewTicket:false})}} onSave={()=>{this.onSaveTicket()}}/>

        }

      </>
    );
  }
}

export default TicketsList;